var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-service-slot":_vm.tagId,"data-tr-component-path":_vm.trComponentPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }